import { Injectable } from '@angular/core'
import { Action, Selector, State, StateContext } from '@ngxs/store'
import { tap } from 'rxjs/operators'
import { FluidsStateModel } from './fluids.model'
import { GetFluidsList, GetFluidsSummary } from './fluids.actions'
import { FluidsService } from '../fluids.service'

@State<FluidsStateModel>({
  name: 'fluids'
})
@Injectable()
export class FluidsState {
  constructor(private fluidsService: FluidsService) {}

  @Selector()
  static summaryResponse(state: FluidsStateModel) {
    return state.summaryResponse
  }

  @Selector()
  static listResponse(state: FluidsStateModel) {
    return state.listResponse
  }

  @Action(GetFluidsSummary)
  getFluidsSummary(ctx: StateContext<FluidsStateModel>, { payload }: GetFluidsSummary) {
    ctx.patchState({
      summaryResponse: undefined
    })
    return this.fluidsService.getFluidsSummary(payload).pipe(
      tap((res) => {
        ctx.patchState({
          summaryResponse: res
        })
      })
    )
  }

  @Action(GetFluidsList)
  getFluidsList(ctx: StateContext<FluidsStateModel>, { info }: GetFluidsList) {
    ctx.patchState({
      listResponse: undefined
    })
    return this.fluidsService.getFluidsList(info).pipe(
      tap((res) => {
        ctx.patchState({
          listResponse: res
        })
      })
    )
  }
}
